import {ukStyleDate} from '@peachy/utility-kit-pure'
import {Component} from 'solid-js'

export const InfoPanelPlanStartDate: Component<{ startDate: Date}> = (props) => <p>Plan start date: <span>{ukStyleDate(props.startDate)}</span></p>
